import React from 'react';
import { Trans } from 'react-i18next';

import { Container } from '../base-components';

export const GDPREspacePerso: React.FC = () => {
    return (
        <Container>
            <p>
                <Trans i18nKey="gdpr.espacePerso.part1">
                    part1
                    <a
                        href="https://www.printemps.com/fr/fr/protection-donnees-personnelles"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        ici
                    </a>
                    part2
                </Trans>
                <br />
                <Trans i18nKey="shared.mentions.requiredFields" />
                <br />
                <Trans i18nKey="gdpr.espacePerso.part2" />
            </p>
        </Container>
    );
};
